import { Document } from '@app/graphql/types'
import { isDownloadUserDocumentsLink, withFreshAuthTokens } from '@app/modules/Auth/documentLink'
import { requireAuthToken } from '@app/modules/Auth/resolveAuthToken'
import SDK from '@app/SDK'

export type DownloadableDocument = Pick<Document, 'id' | 'fileUrl'>

const downloadFile = (url: string): void => {
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = url
  document.body.appendChild(iframe)

  setTimeout(() => {
    document.body.removeChild(iframe)
  }, 5000)
}

const createSignedDownloadUrls = async (documentIds: number[]): Promise<string[]> => {
  const token = await requireAuthToken()
  const signedUrlsByDocumentId = await SDK.downloadUserDocuments.createLinksForDocuments(
    token,
    documentIds,
    true
  )

  return Object.values(signedUrlsByDocumentId)
}

const resolveDownloadUrls = async (documents: DownloadableDocument[]): Promise<string[]> => {
  const userDocumentIds = documents
    .filter(({ fileUrl }) => isDownloadUserDocumentsLink(fileUrl))
    .map(({ id }) => id)
  const directUrls = documents
    .map(({ fileUrl }) => fileUrl)
    .filter((fileUrl) => !isDownloadUserDocumentsLink(fileUrl))

  if (userDocumentIds.length === 0) {
    return directUrls
  }

  try {
    return [...(await createSignedDownloadUrls(userDocumentIds)), ...directUrls]
  } catch {
    return withFreshAuthTokens(
      documents.map(({ fileUrl }) => fileUrl),
      { download: true }
    )
  }
}

export default async function multiDownloader(documents: DownloadableDocument[]): Promise<void> {
  const urls = await resolveDownloadUrls(documents)

  urls.forEach(downloadFile)
}
